module.exports = __webpack_public_path__ + "f7d5fa0258940e2c3ac9bb2c2ec57633.svg";